export const loginFormStepsEnum = {
  loginInfo: 1,
  OTP: 2,
};
